module.exports = __webpack_public_path__ + "static/media/difdisplay-webfont.ad4eb179.woff2";